export const PERMISSION_GROUPS = [
  {
    label: 'Financial data',
    permissions: [
      { key: 'financials.view', label: 'View financial data', description: 'View deal values, revenue, budgets and activation costs.' },
      { key: 'financials.manage', label: 'Manage financial data', description: 'Create and edit deal values, budgets and allocations.' }
    ]
  },
  {
    label: 'Commercial workspace',
    permissions: [
      { key: 'clients.manage', label: 'Manage clients', description: 'Create, edit and remove clients.' },
      { key: 'projects.manage', label: 'Manage projects', description: 'Create, edit and organise projects and portfolios.' },
      { key: 'deals.manage', label: 'Manage deals', description: 'Create, edit and remove deals.' },
      { key: 'rights.manage', label: 'Manage rights and deliveries', description: 'Create, edit and remove rights and delivery records.' },
      { key: 'reports.export', label: 'Export reports', description: 'Generate and export reports.' }
    ]
  },
  {
    label: 'CRM',
    permissions: [
      { key: 'crm.view', label: 'View CRM', description: 'Access CRM records within assigned workspaces and Businesses.' },
      { key: 'crm.manage', label: 'Manage CRM records', description: 'Create and edit leads, companies, contacts, opportunities, activities and tasks.' },
      { key: 'crm.settings.manage', label: 'Manage CRM settings', description: 'Configure CRM workspaces, Businesses and pipeline stages.' }
    ]
  },
  {
    label: 'Administration',
    permissions: [
      { key: 'templates.manage', label: 'Manage right templates', description: 'Create and edit reusable right templates.' },
      { key: 'team.manage', label: 'Manage team', description: 'Invite, remove and change team members.' },
      { key: 'permissions.manage', label: 'Manage permission sets', description: 'Create permission sets and assign them to users.' }
    ]
  }
]

export const ALL_PERMISSIONS = PERMISSION_GROUPS.flatMap(group =>
  group.permissions.map(permission => permission.key)
)

export function getEffectivePermissions(profile) {
  if (profile?.role === 'admin' || profile?.is_platform_admin) return ALL_PERMISSIONS
  return profile?.permission_sets?.permissions || []
}

export function hasPermission(profile, permission) {
  return getEffectivePermissions(profile).includes(permission)
}
